interface Tab<T extends string> {
  id: T;
  label: string;
}

interface TabsProps<T extends string> {
  tabs: readonly Tab<T>[];
  active: T;
  onChange: (id: T) => void;
  /** BEM block whose `__tabs`/`__tab` classes style this list, e.g. "matchups". */
  block: string;
}

/** A row of tab buttons; the caller renders the active tab's content. */
export function Tabs<T extends string>({ tabs, active, onChange, block }: TabsProps<T>) {
  return (
    <div className={`${block}__tabs`} role="tablist">
      {tabs.map(({ id, label }) => (
        <button
          key={id}
          type="button"
          role="tab"
          aria-selected={active === id}
          className={`${block}__tab`}
          onClick={() => onChange(id)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
